var _circle, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.5,
    fill: "white",
    stroke: "#4A90E2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1745_15025",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 10,
    height: 10
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.17969 9.56249H11.4628L8.71781 12.3075C8.49844 12.5269 8.49844 12.8869 8.71781 13.1062C8.93719 13.3256 9.29156 13.3256 9.51094 13.1062L13.2178 9.39936C13.4372 9.17999 13.4372 8.82562 13.2178 8.60624L9.51656 4.89374C9.41147 4.78841 9.26879 4.72922 9.12 4.72922C8.97121 4.72922 8.82853 4.78841 8.72344 4.89374C8.50406 5.11312 8.50406 5.46749 8.72344 5.68687L11.4628 8.43749H5.17969C4.87031 8.43749 4.61719 8.69062 4.61719 8.99999C4.61719 9.30937 4.87031 9.56249 5.17969 9.56249Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1745_15025)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.25,
    y: 2.25,
    width: 13.5,
    height: 13.5,
    fill: "#4A90E2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkArrow);
export default __webpack_public_path__ + "static/media/link_arrow.516e5082f4264e5d5b60d6d30276d953.svg";
export { ForwardRef as ReactComponent };